module.exports = __webpack_public_path__ + "img/loading.77cdc98e.gif";